import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { AnnouncementsContextBlock } from '../../_blocks/Announcements';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';

export type AnnouncementsWidget = ContextWidget<
  AnnouncementsContextBlock,
  | WidgetType.currentannouncementsinbox
  | WidgetType.currentannouncementsoutbox
  | WidgetType.currentmandatoryannouncementsforpage
>;

export function AnnouncementsWidget({ elementType, ...props }: AnnouncementsWidget) {
  const { t } = useSonTranslation('Announcement');
  return (
    <DefaultContextWidget
      icon={Icons.ANNOUNCEMENTS}
      title={t(`widgetTitle.${elementType}`)}
      elementType={elementType}
      {...props}
    />
  );
}
